import { wave } from './config';

const POST_GUEST_USER_CONSENT_ENDPOINT = '/v2/customers/guest';

export default async function postGuestCredentials(body) {
  const headers = {
    appId: process.env.appId,
  };
  try {
    const response = await wave.post(POST_GUEST_USER_CONSENT_ENDPOINT, body, { headers });
    if (response.status !== 201) {
      throw Error('Request failed');
    }
    return {};
  } catch (error) {
    const userMessage =
      error.response?.data?.error?.userMessage ||
      'Κάτι πήγε στραβά στην υποβολή της φόρμας. Παρακαλούμε προσπάθησε ξανά.';
    return { error: userMessage };
  }
}
